import React, { useState } from 'react';
import logo from '../assets/logo.png'; // adjust path as needed

const createMathQuestion = () => ({
  left: Math.floor(Math.random() * 9) + 1,
  right: Math.floor(Math.random() * 9) + 1,
});

function Login({ onLogin }) {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [question, setQuestion] = useState(createMathQuestion);
  const [answer, setAnswer] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const refreshQuestion = () => {
    setQuestion(createMathQuestion());
    setAnswer('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError('');

    if (!/^\d+$/.test(answer.trim()) || Number(answer) !== question.left + question.right) {
      setError('Please enter the correct answer to the math question.');
      return;
    }

    setSubmitting(true);
    try {
      const response = await fetch('https://api.stitchtechsolutions.com/api/login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier, password }),
      });

      const text = await response.text();
      const result = JSON.parse(text);

      if (result.status === 'success') {
        // ✅ Store session token in localStorage
        localStorage.setItem('session_token', result.user.session_token);
        localStorage.setItem('user_id', result.user.id); // optional for validation
        onLogin(result.user); // pass to parent
      } else {
        setError(result.message || 'Login failed. Please try again.');
        refreshQuestion();
      }
    } catch (error) {
      setError('Something went wrong. Please try again.');
      refreshQuestion();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <img src={logo} alt="Logo" className="sidebar-logo" />
        <h2>Login</h2>
        {error && <div className="error-message" role="alert">{error}</div>}
        <input
          type="text"
          placeholder="Username or Email"
          value={identifier}
          onChange={e => setIdentifier(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
        <div className="login-math-check">
          <label htmlFor="login-math-answer">
            Quick math check: {question.left} + {question.right} = ?
          </label>
          <input
            id="login-math-answer"
            type="text"
            inputMode="numeric"
            pattern="[0-9]+"
            autoComplete="off"
            placeholder="Your answer"
            value={answer}
            onChange={e => setAnswer(e.target.value)}
            disabled={submitting}
            required
          />
          <button type="button" className="login-math-refresh" disabled={submitting} onClick={refreshQuestion}>
            New question
          </button>
        </div>
        <button type="submit" disabled={submitting}>{submitting ? 'Logging in…' : 'Login'}</button>
      </form>
    </div>
  );
}

export default Login;
